import { Container, Grid } from "@mui/material";
import React from "react";
import { ActionComponent } from "../plugin_api";

interface WrapperProps<T> {
  children:
    | React.ReactElement<ActionComponent<T>>
    | [React.ReactElement<ActionComponent<T>>, React.ReactElement<ActionComponent<T>>];
}

function ActionComponentWrapper<T>({ children }: WrapperProps<T>) {
  const [mainComponent, rhsComponent] = React.Children.toArray(children);
  return (
    <Container
      sx={{
        marginTop: { xs: "0", md: "1rem" },
        marginBottom: { xs: "1.5rem", md: "1rem" },
        paddingX: { xs: "8px" },
      }}
    >
      <Grid
        container
        justifyContent={"flex-end"}
        columns={10}
        spacing={3}
        sx={{
          marginTop: "0",
        }}
      >
        <Grid item sx={{ paddingTop: { xs: "0px !important", md: "1rem" } }} xs={10} md={7}>
          {mainComponent}
        </Grid>
        <Grid item xs={10} md={3} sx={{ paddingTop: { md: "0px !important" } }}>
          {rhsComponent}
        </Grid>
      </Grid>
    </Container>
  );
}

export { ActionComponentWrapper };
